import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import PhotosInput from '@components/form/photos/PhotosInput'
import DragDropArea from '@components/form/photos/DragDropArea'
import Actions from '@components/form/photos/Actions'
import ImageEditor from '@components/form/photos/ImageEditor'
import MessageHelper from '@utils/messageHelper'
import Alert from '@components/display/Alert'
import Error from '@components/form/validation/Error'

import createPipeline from '@components/form/photos/functions/createPipeline'
import blobCloneMetadata from '@components/form/photos/functions/blobCloneMetadata'
import fileCreateBrowserPreview from '@components/form/photos/functions/fileCreateBrowserPreview'
import fileTrashBrowserPreview from '@components/form/photos/functions/fileTrashBrowserPreview'
import fileUpdateMetadata from '@components/form/photos/functions/fileUpdateMetadata'
import fileMarkAsProcessed from '@components/form/photos/functions/fileMarkAsProcessed'
import createFilePreloadToServer from '@components/form/photos/functions/createFilePreloadToServer'
import fileGetDataBeforePost from '@components/form/photos/functions/fileGetDataBeforePost'

import getPhotosFromPid from './functions/asyncGetPhotosFromPid'

const onFileDelete = createPipeline([
    fileTrashBrowserPreview
])

const onFileEdit = createPipeline([
    blobCloneMetadata
])

const onFileOrderChange = createPipeline([
    fileUpdateMetadata
])

const onDefaultPreload = createPipeline([
    fileCreateBrowserPreview,
    fileUpdateMetadata,
    fileMarkAsProcessed,
])

const onExit = onFileDelete

const onCallback = createPipeline([
    fileGetDataBeforePost
])

const DefaultPhotos = (props) => {
    const { user: { token } = {}} = props
    const { setProgress } = useFormContext()

    const onFileEntry = useMemo(() => {
        const filePreloadToServer = createFilePreloadToServer(token, setProgress)
        return createPipeline([
            fileCreateBrowserPreview,
            fileUpdateMetadata,
            filePreloadToServer,
        ])
    }, [token])

    return (
        <>
            <Alert>
                Dla lepszej widoczności staraj się dodawać zdjęcia zrobione poziomo
            </Alert>

            { props.error && <Error name="zdjecia" /> }

            <PhotosInput {...{
                DragDropArea,
                Actions,
                ImageEditor,
                MessageHelper,

                onFileEntry,

                onFileDelete,
                onFileEdit,
                onFileOrderChange,
                onDefaultPreload,
                onCancel: null,
                onSave: null,
                onExit,

                onCallback }}

                getDefaultValues={getPhotosFromPid}

                debug={false}

                limit={30}
                name="zdjecia"
                required

                {...props} />
        </>
    )
}

export default DefaultPhotos